@if(isDev()){
<div class='dev-banner-part'>
	<div class='dev-banner'>Dev</div>
</div>
}